module.exports = __webpack_public_path__ + "static/media/contact-icon-new.cbbc122d.png";